export default {"src":"/_next/static/media/br.0bdeddfd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};